module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/collab/collab-scroll-04-6e3503a71981f44c197fc5e220779cd2.jpg";